'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardPaymentForm = exports.CardPaymentFormUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _decorator = require('helpers/decorator');

var _InputField = require('components/FormFields/InputField');

var _withStripeElements = require('components/PaymentMethods/withStripeElements');

var _StripeElements = require('../StripeElements');

var _CurrentCardDetails = require('./CurrentCardDetails');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardPaymentFormUnwrapped = exports.CardPaymentFormUnwrapped = function (_Component) {
  (0, _inherits3.default)(CardPaymentFormUnwrapped, _Component);

  function CardPaymentFormUnwrapped(props) {
    var _ref;

    var _this, _this7;

    (0, _classCallCheck3.default)(this, CardPaymentFormUnwrapped);

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = (_this7 = (0, _possibleConstructorReturn3.default)(this, (_ref = CardPaymentFormUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(CardPaymentFormUnwrapped)).call.apply(_ref, [this, props].concat(args))), _this7);

    _this7.state = {};
    _this7.elementEls = {};

    _this7.clearElement = function (elementName) {
      var element = _this.elementEls[elementName];
      // As some elements may be conditionally-rendered
      // only clear those that were not previously destroyed
      if (element && !element._destroyed) {
        // eslint-disable-line no-underscore-dangle
        element.clear();
      }
    };

    _this7.defaultFormRenderer = _this7.defaultFormRenderer.bind(_this7);
    _this7.getStripeTokenPromise = _this7.getStripeTokenPromise.bind(_this7);
    _this7.renderCardName = _this7.renderCardName.bind(_this7);
    _this7.renderCardNumber = _this7.renderCardNumber.bind(_this7);
    _this7.renderCardCVC = _this7.renderCardCVC.bind(_this7);
    _this7.renderCardExpiry = _this7.renderCardExpiry.bind(_this7);
    _this7.renderPostalCode = _this7.renderPostalCode.bind(_this7);

    props.setStripePromise(_this7.getStripeTokenPromise);
    return _this7;
  }

  (0, _createClass3.default)(CardPaymentFormUnwrapped, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadAddressRequirements(this.props.countryShortCode);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(_ref2) {
      var countryShortCode = _ref2.countryShortCode;

      // Sometimes when the pages first mounts, the countryShortCode
      // is not yet loaded (e.g. not until the data for the plan's page has loaded
      // does it have that plan's msa's data)
      if (this.props.countryShortCode !== countryShortCode) {
        this.loadAddressRequirements(this.props.countryShortCode);
      }
    }
  }, {
    key: 'getStripeTokenPromise',
    value: function getStripeTokenPromise() {
      var _this2 = this;

      var _props = this.props,
          onLoadingStateChanged = _props.onLoadingStateChanged,
          ccName = _props.ccName,
          allowPrepaidCards = _props.allowPrepaidCards,
          stripe = _props.stripe;


      onLoadingStateChanged(true);

      var extraData = ccName ? { name: ccName.input.value } : {};

      return stripe.createToken(this.elementEls.cardNumber, extraData).then(function (_ref3) {
        var token = _ref3.token,
            error = _ref3.error;

        if (error) {
          error.isStripeError = true;
          throw error;
        }

        if (token && token.card && token.card.funding === 'prepaid' && !allowPrepaidCards) {
          throw new Error('There was a problem with your request because prepaid cards are not accepted. Please enter a different payment method or contact us here for help.');
        }

        onLoadingStateChanged(false);

        _this2.clearElements();

        return token.id;
      }).catch(function (err) {
        if (err && err.type !== 'validation_error') {
          _this2.setState({ error: err.message });
        }
        onLoadingStateChanged(false);
        throw err;
      });
    }
  }, {
    key: 'loadAddressRequirements',
    value: function loadAddressRequirements(countryShortCode) {
      var loadAddressRequirements = this.props.loadAddressRequirements;

      // - As not all components using CardPaymentForm are wrapped
      //   by a container, we only want to loadAddressRequirements for those which are
      //   wrapped with the loadAddressRequirements action

      if (loadAddressRequirements && countryShortCode) {
        loadAddressRequirements(countryShortCode);
      }
    }
  }, {
    key: 'clearElements',
    value: function clearElements() {
      (0, _keys2.default)(this.elementEls).forEach(this.clearElement);
    }
  }, {
    key: 'shouldRenderWithExistingData',
    value: function shouldRenderWithExistingData() {
      return this.props.billing && this.props.useExistingData && this.props.onEditRequest && this.props.billing.data && this.props.billing.data.lastFour;
    }
  }, {
    key: 'canRender',
    value: function canRender() {
      return !this.props.billing || !this.props.billing.loading;
    }
  }, {
    key: 'defaultFormRenderer',
    value: function defaultFormRenderer(_ref4) {
      var error = _ref4.error,
          CardName = _ref4.CardName,
          CardNumber = _ref4.CardNumber,
          CardCVC = _ref4.CardCVC,
          CardExpiry = _ref4.CardExpiry,
          PostalCode = _ref4.PostalCode;
      var _props2 = this.props,
          ccName = _props2.ccName,
          hideZip = _props2.hideZip;


      return _react2.default.createElement(
        'div',
        { className: 'form' },
        error && _react2.default.createElement(
          'div',
          { className: 'grid__item error__text mb' },
          error
        ),
        _react2.default.createElement(
          'ul',
          null,
          ccName && _react2.default.createElement(CardName, {
            wrapperTag: 'li',
            label: _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'payment-form.ccNameLabel',
              defaultMessage: 'Name on Card'
            })
          }),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'div',
              { className: 'grid grid--md' },
              _react2.default.createElement(
                'div',
                { className: 'grid__item 2/3' },
                _react2.default.createElement(CardNumber, {
                  label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'payment-form.ccNumberLabel',
                    defaultMessage: 'Card Number'
                  })
                })
              ),
              _react2.default.createElement(
                'div',
                { className: 'grid__item 1/3' },
                _react2.default.createElement(CardCVC, {
                  label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'payment-form.ccCv2Label',
                    defaultMessage: 'CVC'
                  })
                })
              )
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'div',
              { className: 'grid grid--md' },
              _react2.default.createElement(
                'div',
                { className: 'grid__item 1/2' },
                _react2.default.createElement(CardExpiry, {
                  label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'payment-form.ccExpiry',
                    defaultMessage: 'Expiration Date'
                  })
                })
              ),
              !hideZip && _react2.default.createElement(
                'div',
                { className: 'grid__item 1/2' },
                _react2.default.createElement(PostalCode, {
                  label: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'payment-form.ccPostalCodeLabel',
                    defaultMessage: 'Billing Postal Code'
                  })
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderWithExistingData',
    value: function renderWithExistingData() {
      var _props3 = this.props,
          onEditRequest = _props3.onEditRequest,
          billingData = _props3.billing.data;


      return _react2.default.createElement(
        'div',
        { className: 'form__existing-info' },
        _react2.default.createElement(_reactIntl.FormattedMessage, {
          tagName: 'p',
          id: 'payment-form.saved-info',
          defaultMessage: 'Your saved card number'
        }),
        _react2.default.createElement(_CurrentCardDetails.CurrentCardDetails, billingData),
        _react2.default.createElement(
          'a',
          { onClick: onEditRequest },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            tagName: 'p',
            id: 'payment-form.edit-existing',
            defaultMessage: 'Edit'
          })
        )
      );
    }
  }, {
    key: 'renderCardName',
    value: function renderCardName(extraProps) {
      var ccName = this.props.ccName;


      return _react2.default.createElement(_InputField.InputField, (0, _extends3.default)({}, ccName, {
        inputAttributes: {
          autoComplete: 'cc-name'
        }
      }, extraProps));
    }
  }, {
    key: 'renderCardNumber',
    value: function renderCardNumber(_ref5) {
      var _this3 = this;

      var label = _ref5.label;
      var elements = this.props.elements;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        label && _react2.default.createElement(
          'label',
          { htmlFor: 'card-number' },
          label
        ),
        _react2.default.createElement(_StripeElements.CardNumberElement, {
          elements: elements,
          elementRef: function elementRef(el) {
            return _this3.elementEls.cardNumber = el;
          },
          key: 'card-number'
        })
      );
    }
  }, {
    key: 'renderCardCVC',
    value: function renderCardCVC(_ref6) {
      var _this4 = this;

      var label = _ref6.label;
      var elements = this.props.elements;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        label && _react2.default.createElement(
          'label',
          { htmlFor: 'card-cvc' },
          label
        ),
        _react2.default.createElement(_StripeElements.CardCVCElement, {
          elements: elements,
          elementRef: function elementRef(el) {
            return _this4.elementEls.cardCvc = el;
          },
          key: 'card-cvc'
        })
      );
    }
  }, {
    key: 'renderCardExpiry',
    value: function renderCardExpiry(_ref7) {
      var _this5 = this;

      var label = _ref7.label;
      var elements = this.props.elements;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        label && _react2.default.createElement(
          'label',
          { htmlFor: 'card-expiry' },
          label
        ),
        _react2.default.createElement(_StripeElements.CardExpiryElement, {
          elements: elements,
          elementRef: function elementRef(el) {
            return _this5.elementEls.cardExpiry = el;
          },
          key: 'card-expiry'
        })
      );
    }
  }, {
    key: 'renderPostalCode',
    value: function renderPostalCode(_ref8) {
      var _this6 = this;

      var label = _ref8.label;
      var elements = this.props.elements;


      return _react2.default.createElement(
        _react.Fragment,
        null,
        label && _react2.default.createElement(
          'label',
          { htmlFor: 'billing-zip' },
          label
        ),
        _react2.default.createElement(_StripeElements.PostalCodeElement, {
          onBlur: function onBlur(value) {
            return _this6.props.onZipBlur && _this6.props.onZipBlur(value);
          },
          onChange: function onChange(evt) {
            return _this6.props.onZipChange && _this6.props.onZipChange(evt.value);
          },
          elements: elements,
          elementRef: function elementRef(el) {
            return _this6.elementEls.postalCode = el;
          },
          key: 'card-postal-code'
        })
      );
    }
  }, {
    key: 'renderWithForm',
    value: function renderWithForm(formRenderer) {
      var error = this.state.error;


      return formRenderer({
        error: error,
        CardName: this.renderCardName,
        CardNumber: this.renderCardNumber,
        CardCVC: this.renderCardCVC,
        CardExpiry: this.renderCardExpiry,
        PostalCode: this.renderPostalCode
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.canRender()) {
        return false;
      }

      if (this.shouldRenderWithExistingData()) {
        return this.renderWithExistingData();
      }

      var children = this.props.children;


      var formRenderer = typeof children === 'function' ? children : this.defaultFormRenderer;

      return this.renderWithForm(formRenderer);
    }
  }]);
  return CardPaymentFormUnwrapped;
}(_react.Component);

CardPaymentFormUnwrapped.propTypes = {
  billing: _propTypes2.default.shape({
    loading: _propTypes2.default.bool,
    data: _propTypes2.default.shape({
      lastFour: _propTypes2.default.string
    }),
    error: _propTypes2.default.string
  }),
  ccName: _propTypes2.default.object,
  children: _propTypes2.default.func,
  countryShortCode: _propTypes2.default.string,
  elements: _propTypes2.default.object,
  hideZip: _propTypes2.default.bool,
  loadAddressRequirements: _propTypes2.default.func.isRequired,
  onEditRequest: _propTypes2.default.func,
  onLoadingStateChanged: _propTypes2.default.func,
  onZipBlur: _propTypes2.default.func,
  onZipChange: _propTypes2.default.func,
  useExistingData: _propTypes2.default.bool,
  allowPrepaidCards: _propTypes2.default.bool,
  setStripePromise: _propTypes2.default.func.isRequired,
  stripe: _propTypes2.default.shape({
    getSource: _propTypes2.default.func,
    getToken: _propTypes2.default.func
  })
};

var CardPaymentForm = exports.CardPaymentForm = (0, _decorator.decorateWith)(_withStripeElements.withStripeElements, _reactIntl.injectIntl)(CardPaymentFormUnwrapped);